import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";
import { Reveal, RevealText } from "@/lib/motion";
import { useConsent } from "@/lib/consent";

const CookieRow = ({ cat, name, purpose, duration, third }) => (
  <tr className="border-t border-[#151515]">
    <td className="p-3 font-mono-tech text-[11px] text-white/60">{cat}</td>
    <td className="p-3 text-white/80 text-sm">{name}</td>
    <td className="p-3 text-white/70 text-sm">{purpose}</td>
    <td className="p-3 font-mono-tech text-[11px] text-white/60">{duration}</td>
    <td className="p-3 font-mono-tech text-[11px] text-white/60">{third}</td>
  </tr>
);

export default function CookiePolicyPage() {
  const { open } = useConsent();
  return (
    <div className="pt-24 pb-24">
      <section className="py-16 border-b border-[#141414]">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <Reveal>
            <Link to="/" className="font-mono-tech text-white/60 hover:text-[#ff4b00]"><ArrowLeft size={12} className="inline mr-1" />Home</Link>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="num-chip my-6"><span className="dot" /> Documento legale · ePrivacy + GDPR</div>
          </Reveal>
          <RevealText text="Cookie Policy" className="font-display text-white text-[12vw] md:text-[6vw] leading-[0.9]" />
          <Reveal delay={0.2}>
            <p className="text-white/70 max-w-2xl mt-6">
              Il presente documento descrive come utilizziamo cookie e tecnologie simili sul sito
              di Gefion S.r.l., ai sensi dell'art. 122 del D.Lgs. 196/2003 e delle Linee Guida del Garante Privacy.
            </p>
            <div className="mt-8">
              <button onClick={open} className="btn-primary" data-testid="cookie-open-prefs"><Cookie size={14} /> Gestisci preferenze cookie</button>
            </div>
          </Reveal>
        </div>
      </section>

      <div className="max-w-[1200px] mx-auto px-6 md:px-10 pt-12 space-y-10">
        <section>
          <div className="font-mono-tech text-white/50 mb-3">◇ Cosa sono i cookie</div>
          <div className="font-display text-2xl md:text-3xl mb-4">Piccoli file, grandi conseguenze.</div>
          <p className="text-white/70 text-[15px] leading-relaxed">
            I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente,
            dove vengono memorizzati per essere ritrasmessi al sito nelle visite successive. Alcuni sono
            <strong className="text-white"> tecnici</strong> e non richiedono consenso; altri sono <strong className="text-white">analitici o di marketing</strong> e richiedono
            il tuo consenso esplicito prima di essere attivati.
          </p>
        </section>

        <section>
          <div className="font-mono-tech text-white/50 mb-3">◈ Categorie di cookie utilizzati</div>
          <div className="border border-[#1a1a1a] overflow-x-auto">
            <table className="w-full text-left text-[13px] min-w-[720px]">
              <thead className="bg-[#0a0a0a] text-white/60"><tr>
                <th className="p-3">Categoria</th><th className="p-3">Nome</th><th className="p-3">Finalità</th><th className="p-3">Durata</th><th className="p-3">Fornitore</th>
              </tr></thead>
              <tbody>
                <CookieRow cat="Essenziali" name="access_token" purpose="Autenticazione area riservata" duration="7 giorni" third="Gefion (1st party)" />
                <CookieRow cat="Essenziali" name="gefion_token / gefion_customer_token" purpose="Sessione admin / cliente" duration="7 giorni" third="localStorage 1st party" />
                <CookieRow cat="Essenziali" name="gefion_consent" purpose="Memorizza le preferenze cookie dell'utente" duration="12 mesi" third="Gefion (1st party)" />
                <CookieRow cat="Analitici" name="ph_*" purpose="Statistiche anonime di visita (PostHog)" duration="12 mesi" third="PostHog · UE" />
              </tbody>
            </table>
          </div>
          <p className="text-white/60 text-sm mt-4">
            I cookie <strong className="text-white">essenziali</strong> sono sempre attivi perché indispensabili al funzionamento del sito.
            I cookie <strong className="text-white">analitici</strong> vengono attivati SOLO se l'utente presta consenso esplicito tramite il banner.
          </p>
        </section>

        <section>
          <div className="font-mono-tech text-white/50 mb-3">◐ Come gestire le preferenze</div>
          <p className="text-white/70 text-[15px]">Puoi modificare o revocare il tuo consenso in qualsiasi momento:</p>
          <ul className="list-disc pl-6 space-y-1 mt-3 text-white/70">
            <li>Cliccando su <button onClick={open} className="text-[#ff4b00] underline">Gestisci preferenze cookie</button> in questa pagina</li>
            <li>Dalle impostazioni del tuo browser (Chrome, Firefox, Safari, Edge)</li>
            <li>Utilizzando la modalità di navigazione in incognito</li>
          </ul>
        </section>

        <section>
          <div className="font-mono-tech text-white/50 mb-3">◉ Contatti</div>
          <p className="text-white/70 text-[15px]">
            Per domande sul trattamento cookie: <a href="mailto:info@gefion-evolution.it" className="text-[#ff4b00] hover:underline">info@gefion-evolution.it</a>
          </p>
          <p className="font-mono-tech text-[11px] text-white/40 mt-8">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long", day: "numeric" })}</p>
        </section>
      </div>
    </div>
  );
}
